module.exports = __webpack_public_path__ + "static/media/mascote-panda@2x.49e381ff.jpg";